import React from 'react';
import FormModal from '../../shared/components/custom/FormModal';
import SectionLabelComponentForm from './SectionLabelComponentForm';
import t, { partial } from '../../util/translation/translation';

const SectionLabelComponent = ({
  showModal,
  onClose,
  selectedComponent,
  onSave,
}) => {
  const compName =
    selectedComponent?.id === 'section-label' ? 'sectionLabel' : null;
  if (!compName) {
    return null;
  }
  const s = partial('shared');

  const promptTitle = `${selectedComponent?.value ? s('edit') : s('create')} ${t(`appLayout.${compName}`)}`;
  const handleSubmit = (values) => {
    const payload = {
      ...selectedComponent,
      value: values.title,
      label: values.title,
    };
    onSave(payload);
  };
  return (
    <FormModal
      isOpen={!!showModal}
      onClose={onClose}
      title={promptTitle}
      subtitle={t('appLayout.modalHintSectionLabel')}
    >
      <SectionLabelComponentForm
        component={selectedComponent}
        onSubmit={handleSubmit}
        onClose={onClose}
      />
    </FormModal>
  );
};
export default SectionLabelComponent;
